import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { postCoreDataSecurityAlertsExportSlice } from './post';

export const coreDataSecurityAlertsExportReducers = combineReducers({
	post: postCoreDataSecurityAlertsExportSlice.asyncReducers
});

export const coreDataSecurityAlertsExportWatchers = combineAllWatchers([
	postCoreDataSecurityAlertsExportSlice.asyncWatchers
]);
